import { useTranslation } from 'react-i18next';
import { ApartmentStatus } from '../types/apartment';

interface ApartmentStatusBadgeProps {
  readonly status: ApartmentStatus;
}

// Record<ApartmentStatus, string> enforces exhaustiveness — adding a 4th status
// causes a compile error here rather than a silent runtime gap (Effective TypeScript §28).
const STATUS_STYLES: Record<ApartmentStatus, string> = {
  DRAFT: 'bg-gray-100 text-gray-700',
  PUBLISHED: 'bg-green-100 text-green-700',
  UNPUBLISHED: 'bg-amber-100 text-amber-700',
};

export const ApartmentStatusBadge = ({ status }: ApartmentStatusBadgeProps) => {
  const { t } = useTranslation('badges');

  const STATUS_KEYS: Record<ApartmentStatus, string> = {
    DRAFT: t('statusDraft'),
    PUBLISHED: t('statusPublished'),
    UNPUBLISHED: t('statusUnpublished'),
  };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${STATUS_STYLES[status]}`}
    >
      {STATUS_KEYS[status]}
    </span>
  );
};
